/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagDisplayInfos } from '../../models/tag-display-infos';

export interface GetStationNumericsTags$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getStationNumericsTags(http: HttpClient, rootUrl: string, params: GetStationNumericsTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagDisplayInfos>>> {
  const rb = new RequestBuilder(rootUrl, getStationNumericsTags.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagDisplayInfos>>;
    })
  );
}

getStationNumericsTags.PATH = '/stations/{uid}/tags/numeric';
